export default __webpack_public_path__ + "static/media/celebration.5f450c9e.svg";